/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Heading, FlexCol, FlexRow, TextField, Select } from 'sarsaparilla';

import { changeTicketHolderDetails } from '../../actions/orderDetailsActions';
import { vehicleTypeOptionsTimedEntry } from '../../utils/utils';

export default function VehicleDetails({ addValidationRef }) {
    const dispatch = useDispatch();
    const { vehicleType, licensePlate } = useSelector(
        (reduxState) => reduxState.timedEntry.orderDetails.ticketHolderDetails
    );

    return (
        <section>
            <Heading headingLevel={3} appearance="h6" className="mb-2">
                Vehicle Details
            </Heading>
            <FlexRow className="mb-md-2">
                <FlexCol md={6} className="mb-2 mb-md-0">
                    <Select
                        id="vehicle-type"
                        label="Vehicle Type"
                        isRequired
                        options={vehicleTypeOptionsTimedEntry}
                        value={vehicleType}
                        placeholder="Choose a vehicle type ..."
                        onChange={(event) => {
                            dispatch(
                                changeTicketHolderDetails(
                                    {
                                        vehicleType: event.target.value,
                                    },
                                    true
                                )
                            );
                        }}
                        ref={addValidationRef(5)}
                    />
                </FlexCol>
                <FlexCol md={6} className="mb-2 mb-md-0">
                    <TextField
                        id="license-plate"
                        label="License Plate Number"
                        isRequired={vehicleType === 'personal'}
                        isDisabled={vehicleType !== 'personal'}
                        placeholder={
                            vehicleType !== 'personal'
                                ? 'Only required for personal vehicles'
                                : null
                        }
                        value={licensePlate}
                        onChange={(event) => {
                            dispatch(
                                changeTicketHolderDetails(
                                    {
                                        licensePlate: event.target.value,
                                    },
                                    true
                                )
                            );
                        }}
                        ref={addValidationRef(6)}
                    />
                </FlexCol>
            </FlexRow>
        </section>
    );
}

VehicleDetails.propTypes = {
    addValidationRef: PropTypes.func,
};
